<!--  -->
<template>
  <div v-if="value" class="BasePopup-Component">
    <div class="basePopup-content">
      <i class="btn-close" @click="close"></i>
      <slot></slot>
      <div
        :class="[
          'right-top-change',
          { showPhoneLogin: showPhoneLogin && activeTab !== 3 }
        ]"
        @click="changeLogin"
      ></div>

      <div class="bottom-gray">
        <div class="apple-icon" @click="goStore('apple')"></div>
        <div class="google-icon" @click="goStore('google')"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /* eslint-disable-next-line */
  props: ['value', 'showPhoneLogin', 'activeTab'],
  watch: {
    value(val) {
      const type = val ? 'open' : 'close';
      this.$emit(type);
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    changeLogin() {
      this.$emit('changeLogin');
    },
    goStore(type) {
      let url = 'https://play.google.com/store/apps/details?id=sg.bigo.live';
      if (type === 'apple') {
        url = 'https://itunes.apple.com/app/id1077137248';
      }
      window.open(url, '_blank');
    }
  }
};
</script>
<style lang="scss" scoped>
.BasePopup-Component {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.basePopup-content {
  position: absolute;
  width: 380px;
  height: 598px;
  left: 50%;
  top: 50%;
  margin-left: -190px;
  margin-top: -299px;
  background: #fff;
  border-radius: 12px;

  .btn-close {
    position: absolute;
    z-index: 9;
    cursor: pointer;
    left: 10px;
    top: 10px;
    width: 20px;
    height: 20px;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('~@/assets/img/login/close.png');
  }

  .right-top-change {
    position: absolute;
    right: 0;
    top: 0;
    width: 45px;
    height: 45px;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('~@/assets/img/scan_phone.png');
    cursor: pointer;

    &.showPhoneLogin {
      background-image: url('~@/assets/img/scan_qrcode.png');
    }
  }

  .bottom-gray {
    position: absolute;
    z-index: 1;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 84px;
    background-color: #f5f7fa;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;

    .apple-icon {
      width: 126px;
      height: 36px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      background-image: url(~@assets/img/social-logo/apple.png);
      margin-right: 25px;
      display: inline-block;
      cursor: pointer;
    }

    .google-icon {
      width: 126px;
      height: 36px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      background-image: url(~@assets/img/social-logo/google.png);
      display: inline-block;
      cursor: pointer;
    }
  }
}
</style>
